import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconApps16 from './IconApps16';
import IconApps20 from './IconApps20';
import IconApps24 from './IconApps24';
import IconApps32 from './IconApps32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconApps = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size16 && !props.filled && <IconApps16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconApps20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconApps24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconApps32 {...props} />}
        </span>
    );
};
IconApps.displayName = 'FondueIconApps';

export default memo(IconApps);
